import React, { useEffect, useState } from "react";
import {
	Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Badge, Table, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import Loader from "common/loader";
import { post, get, put } from "../../helpers/api_helper";
import { LIST_DRIVER_TASK, TASKS_SEARCH, FINISH_DRIVER_TASK, PAYMENT_METHODS_SEARCH, ADD_DRIVER_PAYMENT, UPLOAD_DRIVER_PAYMENT, SHOW_ORDER } from "helpers/api_endpoints";
import Select from "react-select";
import { Trans } from "react-i18next";
import MapComponent from "./MapSelect"
import MapBComponent from "./Map"

const TasksDash = ({ driverId = "" }) => {
	const [change, setChange] = useState(0);
	const [loading, setLoading] = useState(false);
	const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState('');
	const [tasks, setTasks] = useState([]);
	const [paymentMethods, setPaymentMethods] = useState([]);
	const [taskTypes, setTaskTypes] = useState([]);
	const [status, setStatus] = useState('');
	const [orderId, setOrderId] = useState('');
	const [order, setOrder] = useState(null);
	const [taskId, setTaskId] = useState('');
	const [uploadedFile, setUploadedFile] = useState(null);
	const [bankNote, setBankNote] = useState('');
	const [paidAmount, setPaidAmount] = useState(null);

	useEffect(() => {
		post(LIST_DRIVER_TASK, {driverId})
			.then(response => {
				const data = response.data;
				setTasks(data);
			})
			.catch(() => setErrorMsg("Failed to load "));
		post(TASKS_SEARCH)
			.then(response => {
				const data = response.data;
				setTaskTypes(data);
			})
			.catch(() => setErrorMsg("Failed to load "));
		post(PAYMENT_METHODS_SEARCH)
			.then(response => {
				const data = response.data;
				setPaymentMethods(data);
			})
			.catch(() => setErrorMsg("Failed to load "));
		}, []);

    const finishTask = taskId => {
      if(confirm('Are you sure you want to finish this task gracefully?'))
      {
        put(FINISH_DRIVER_TASK, {taskId: taskId})
          .then(response => {
            alert(response.message);
          })
          .catch(() => setErrorMsg("Failed to load "));

      }
    }

		const handleFileUpload = (event) => {
			const file = event.target.files[0];
			setUploadedFile(file);
			// console.log(file.type);
			// if(file.size > 1*1024*1024)
			// {
			// 	setErrorMsg('File size is larger than 1MB');
			// 	setTimeout(()=>{
			// 		setErrorMsg('');
			// 	},1700)
			// }
			// if(file.type != 'image/jpeg' && file.type != 'image/png')
			// {
			// 	setErrorMsg('File type is incorrect');
			// 	setTimeout(()=>{
			// 		setErrorMsg('');
			// 	},1700)
			// }
			// post(`${UPLOAD_FILE}`, { file, type:"banknotes", fullPath:"true" }, {
			// 	headers: {
			// 		'Content-Type': 'multipart/form-data'
			// 	}
			// })
			// 	.then((response) => {
			// 		const data = response.data;
			// 		setBankNote(data.path);
			// 		// setLoading(false);
			// 	})
			// 	.catch((error) => {
			// 	});
		}
		
		const doPayment = () => {
			console.log('selectedPaymentMethodId', selectedPaymentMethodId, order.id, paidAmount??order?.refAmount)
			if(selectedPaymentMethodId == '') return;
			if(selectedPaymentMethodId == 1)
			{
				post(ADD_DRIVER_PAYMENT, {driverId, orderId, amount: paidAmount??order?.refAmount})
				.then(response => {
					alert(response.message);
					finishTask(taskId);
				})
				.catch((err) => setErrorMsg("Failed to load "));

			}
			if(uploadedFile)
			{
				post(UPLOAD_DRIVER_PAYMENT, {driverId, orderId, paymentMethodId: selectedPaymentMethodId, file: uploadedFile },	{headers: {
					'Content-Type': 'multipart/form-data'
				}})
				.then(response => {
					alert(response.message);
					finishTask(taskId);
				})
				.catch(() => setErrorMsg("Failed to load "));

			}
		}

		const handleOrder = orderId => {
			setOrderId(orderId);
			get(`${SHOW_ORDER}/${orderId}`)
			.then(response => {
				setOrder(response.data)
			})
			.catch(() => setErrorMsg("Failed to load "));
		}

		return (
			<Card>
				<CardBody>
					<Row>
						{errorMsg && <Alert color="danger">{errorMsg}</Alert>}
							<Modal size="lg" isOpen={isPaymentModalOpen} toggle={() => {}}>
							<ModalHeader>
								<h5>Payment details</h5>
								<button
								className="btn btn-sm btn-primary"
								onClick={() => {
									setIsPaymentModalOpen(false)
								}}
								>
								Close
								</button>
							</ModalHeader>
							<ModalBody>
								<div>
									<Row>
										<div className="form-group col-md-12 mt-2">
											<h4>{order?.refAmount || 'No Ref amount'}</h4>
											<Row>
											{paymentMethods.map((method, index) =>  method.id != 4 && (
												<div className={selectedPaymentMethodId==method.id?'form-group col-md-3 mt-2 bg-success':'form-group col-md-3 mt-2'} key={index}
													onClick={()=>setSelectedPaymentMethodId(method.id)}
												>
													{method.name}
												</div>

											)
											)}
											</Row>
											<div className="form-group col-md-4 mt-2">
												<div className="form-group col-md-12 mt-2">
													<Label className="form-label"><Trans>Upload bank note</Trans></Label>
													<input className="form-control" type="file" onChange={handleFileUpload} />
												</div>
												{/* <div>

													<img src={bankNote} width="170" height="270" />
												</div> */}

											</div>
											<div className="form-group col-md-3 mt-2">
												<Label className="form-label">
												<Trans>Amount</Trans>
												</Label>
												<Input
												name="paidAmount"
												// value={paidAmount}
												className="form-control"
												placeholder=""
												type="number"
												onChange={(e) => setPaidAmount(e.target.value)}
												></Input>
											</div>
											<Row>
												<div className="form-group col-md-12 mt-2 text-center">
													<Button
														type="button"
														color="success"
														onClick={()=>doPayment()}
													>
														Do Payment
													</Button>
												</div>
											
											</Row>
										</div>
									</Row>
								</div>
							</ModalBody>
							<ModalFooter></ModalFooter>
							</Modal>
							<div className="table-responsive">
								<Table className="table table-striped table-bordered mb-0">
									<thead>
										<tr>
											<th>
												<Trans>Task Id</Trans>
											</th>
											<th>
												<Trans>Order Id</Trans>
											</th>
											{/* <th>
												<Trans>Orders</Trans>
											</th> */}
											<th>
												<Trans>Status</Trans>
											</th>
											<th>#</th>
										</tr>
									</thead>
									<tbody>
										{loading ? (
											<tr>
												<th colSpan={10} className="text-center">
													<Loader></Loader>
												</th>
											</tr>
										) : null}
										{tasks?.map((task, index) => (
											<tr key={index}>
												<td>{taskTypes.find(t => t.id == task.id.split('-')[0])?.name}</td>
												<td><b>{task.id.split('-')[1]}</b></td>
												{/* <td>{task.orderId.join(' - ')}</td> */}
												<td>
													{
														<Badge
															className={
																task.status == 2
																	? "bg-danger"
																	: "bg-success"
															}
														>
															<Trans>
																{task.status == 2
																	? "Started"
																	: "Not statrted"}
															</Trans>
														</Badge>
													}
												</td>
												<td>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => {
									if(task.id.indexOf('42-') > -1)
									{
										handleOrder(task.id.slice(3));
										setTaskId(task.id);
										setIsPaymentModalOpen(true);
									}
									else
                                    	finishTask(task.id)
                                  }}
                                >
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>Finish</Trans>
                                </button>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
					</Row>
				</CardBody>
			</Card>
	);
};

export default TasksDash;
